module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "relative"
  }, [_c('legend', [_vm._v("\n    Weighbridge Docket #" + _vm._s(_vm.index + 1) + "\n\n    "), (_vm.docketIsResubmit) ? _c('span', {
    staticClass: "text-danger pull-right"
  }, [_vm._v("\n      RESUBMIT\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.canDelete) ? _c('ladda-button', {
    staticClass: "btn-circle btn-remove-docket",
    attrs: {
      "on-click": _vm.handleDeleteDocket,
      "type": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control float-label-no-animation"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Docket Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control float-label-no-animation"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Net " + _vm._s(_vm.type) + " Weight")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weight),
      expression: "weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weight = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("tonne")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-sm-6 col-md-7': _vm.notDisabled, 'col-sm-12': _vm.disabled
    }
  }, [_c('div', {
    staticClass: "form-group float-label-control float-label-no-animation"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Docket Image")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.file
    }
  })])]), _vm._v(" "), (_vm.notDisabled) ? _c('div', {
    staticClass: "col-sm-6 col-md-5"
  }, [_c('label', {
    staticClass: "btn btn-primary btn-sm btn-block m-b-md",
    attrs: {
      "for": ("docket-" + (_vm.identifiers.index))
    }
  }, [_c('input', {
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "name": "file",
      "id": ("docket-" + (_vm.identifiers.index)),
      "accept": ".jpg,.jpeg,.png,.gif"
    },
    on: {
      "change": _vm.handleFileSelection
    }
  }), _vm._v("\n        Select File\n      ")])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-6779731c"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/weighbridge/WeighbridgeDocketItem.vue
// module id = 1027
// module chunks = 0